import React from "react";

import '../styles/Bio.css';
import foto from '../styles/images/gallery6.jpg';

const Bio = () => {
    return (
        <div className="bio-container">
            {/* Bloque 1: Introducción clara */}
            <section className="bio-section bio-intro">
                <h1>Bio</h1>
                <p className="bio-intro-text">
                    Alaiak 1985ean sortutako Mungialeko Soinulari Elkartea da. Musika tradizionalaz gain, rocka, folka, popa eta beste hainbat generotako doinuak lantzen ditugu, akordeoia bere ohiko esparrutik ateraz eta eremu berrietara eramanez. 
                    <br />
                    Horri esker, kontzertuak dinamikoak, harrigarriak eta energiaz beterikoak izaten dira, entzulegoarengana hurbiltzeko asmoz.
                </p>
            </section>

            {/* Bloque 2: Imagen fuerte */}
            <section className="bio-section bio-image">
                <img 
                    src={foto} 
                    alt="AlaiaK taldea kontzertuan" 
                    className="bio-main-image"
                />
            </section>

            {/* Bloque 3: Historia breve */}
            <section className="bio-section bio-history">
                <h2>Gure ibilbidea</h2>
                <p>
                    40 urteotan herriko kultur bizitzaren parte izan gara, urtero Santa Zezilia bezalako ospakizunetan edo San Pedro jaietan parte hartuz. Horretaz gain, kalejira eta ekitaldi berezietan parte hartzen dugu, hala nola ospitaleetan, adinekoen egoitzetan eta baita ezkontzetan ere. Gure elkartearen ibilbideak eta historiak Alaiak erreferente izatera eman du, bere jarraikotasunagatik eta, nortasuna galdu gabe, etengabe berritzeko gaitasunagatik.
                </p>
                <p>
                    Elkartearen ezaugarri berezienetako bat bere belaunaldi aniztasuna da, adin eta esperientzia ezberdinak elkartuz elkartearen espiritua bizirik mantentzen da.
                </p>
            </section>

            {/* Bloque 4: Qué nos define */}
            <section className="bio-section bio-values">
                <h2>Gure identitatea</h2>
                <div className="values-grid">
                    <div className="value-card">
                        <h3>Tradizioa bizirik mantendu</h3>
                        <p>Herri-musikaren arnasa eta balsak mantentzen, bere energiaz.</p>
                    </div>
                    <div className="value-card">
                        <h3>Belaunaldi arteko harremana</h3>
                        <p>Belaunaldi eta adin ezberdinetako kideok, bat egiten dugu, bakoitzak bere aletxoa jarriz, musikaz gozatzeko helburua lotuz.</p>
                    </div>
                    <div className="value-card">
                        <h3>Herriarekin lotura</h3>
                        <p>Festetan, gabonetan, kultur ekitaldietan … Mungia da gure agertoki nagusia.</p>
                    </div>
                </div>
            </section>

            {/* Bloque 5: La gente (humanización) */}
            <section className="bio-section bio-people">
                <p className="bio-people-text">
                    Musikari, irakasle eta kulturzaleek osatzen dugu taldea. Bakoitzak bere ekarpenak ditu, eta guztiok elkarrekin alaiak egiten dugu, une bakoitzean, doinu bakoitzean.
                </p>
            </section>

            {/* Bloque 6: CTA suave */}
            <section className="bio-section bio-cta">
                <p>Gurekin harremanetan jarri nahi duzu?</p>
                <a href="/contact" className="btn btn--primary btn--large">
                    Kontaktatu
                </a>
            </section>
        </div>
    );
};

export default Bio;